import { actions, selectors } from 'data'
import { Bank, BankState } from 'data/Payments/BankTransfer/types'
import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import GeneralError from '../../GeneralError'
import InvalidAccount from './InvalidAccount'
import Linked from './Linked'
import NameMismatch from './NameMismatch'
import Pending from './Pending'

type Props = {
  bankId: string
  onBack: () => void
  onDone: (bank: Bank) => void
} & ConnectedProps<typeof connector>

const FETCH_INTERVAL = 3000
enum BankErrors {
  alreadyLinked = 'BANK_TRANSFER_ACCOUNT_ALREADY_LINKED',
  infoNotFound = 'BANK_TRANSFER_ACCOUNT_INFO_NOT_FOUND',
  nameMistmatch = 'BANK_TRANSFER_ACCOUNT_NAME_MISMATCH'
}

const SUCCESS_SHOW_TIME = 5000

const BankStatus = ({ bank, bankId, errorFetchingBank, fetchBank, onBack, onDone }: Props) => {
  // poll bank data effect
  useEffect(() => {
    const interval = setInterval(() => fetchBank(bankId), FETCH_INTERVAL)
    return () => clearInterval(interval)
  }, [bank])

  // call done when active effect, timeout so you can see the UI update
  useEffect(() => {
    if (!bank) return
    if (bank.state === BankState.ACTIVE) {
      setTimeout(() => {
        onDone(bank)
      }, SUCCESS_SHOW_TIME)
    }
  }, [bank])

  if (!bank && errorFetchingBank) {
    return <GeneralError onBack={onBack} />
  }

  if (!bank) return <Pending />

  if (bank.state === BankState.ACTIVE) {
    return <Linked name={bank.details.bankName} />
  }

  if (bank.state === BankState.BLOCKED) {
    switch (bank.error) {
      case BankErrors.nameMistmatch:
        return <NameMismatch onBack={onBack} />
      case BankErrors.infoNotFound:
        return <InvalidAccount onBack={onBack} />
      default:
        return <GeneralError onBack={onBack} />
    }
  }

  return <Pending />
}

const mapStateToProps = (state, props) => ({
  bank: selectors.payments.bankTransfer.getBank(state)(props.bankId),
  errorFetchingBank: selectors.payments.bankTransfer.getBankError(state)(props.bankId)
})

const mapDispatchToProps = (dispatch) => ({
  fetchBank: (bankId) => {
    dispatch(actions.payments.fetchBank(bankId))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(BankStatus)
